import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { ExamsCardsList } from "@/components/exam/exams-cards-list";
import { PageHeader } from "@/components/page-header";
import { useDocumentTitle } from "@/lib/use-document-title";

// Passthrough — the datatable component manages its own namespaced URL
// state (e.g. `exams-page_page=2`); the validator must not strip those.
// `batch` is the only key the route itself reads, used to pre-filter the
// list when arriving from a batch detail link card.
const searchSchema = z
  .object({
    batch: z.string().optional(),
  })
  .passthrough();

export const Route = createFileRoute("/_app/exams/")({
  validateSearch: searchSchema,
  component: ExamsPage,
});

function ExamsPage() {
  useDocumentTitle("Exams");
  const { batch } = Route.useSearch();
  return (
    <>
      <PageHeader eyebrow="Schedule" title="Exams" />
      <ExamsCardsList batchId={batch} />
    </>
  );
}
